import {
  GETBUSINESSNATURESUBCATEGORYLISTADMIN_SUCCESS,
  GETBUSINESSNATURESUBCATEGORYLISTADMIN_FAILED,
  RESET_GETBUSINESSNATURESUBCATEGORYLISTADMIN,
  LOADING_GETBUSINESSNATURESUBCATEGORYLISTADMIN,
  NETWORK_ERROR_GETBUSINESSNATURESUBCATEGORYLISTADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetgetBusinessnetureSubCategoryAdmin = () => {
  return { type: RESET_GETBUSINESSNATURESUBCATEGORYLISTADMIN };
};

const admingetBusinessnetureSubCategory =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETBUSINESSNATURESUBCATEGORYLISTADMIN });
    await adminServices
      .post("getBusinessNatureSubCategoryList", userData, {
        headers: { AuthToken: authTokenIs },
      })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(adminAddOrUpdateCurrencysuccess(res.data));
            break;
          default:
            dispatch(adminAddOrUpdateCurrencyFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETBUSINESSNATURESUBCATEGORYLISTADMIN,
          payload: err,
        });
      });
  };
function adminAddOrUpdateCurrencysuccess(data) {
  return {
    type: GETBUSINESSNATURESUBCATEGORYLISTADMIN_SUCCESS,
    payload: data,
  };
}
function adminAddOrUpdateCurrencyFailed(data) {
  return {
    type: GETBUSINESSNATURESUBCATEGORYLISTADMIN_FAILED,
    payload: data,
  };
}

export {
  resetgetBusinessnetureSubCategoryAdmin,
  admingetBusinessnetureSubCategory,
};
